import { HTMLInputTypeAttribute, InputHTMLAttributes } from "react";
import {
  Controller,
  Control,
  FieldValues,
  Path,
  RegisterOptions,
  FieldPathValue,
} from "react-hook-form";

interface InputTextProps<FieldsType extends FieldValues> {
  type?: HTMLInputTypeAttribute;
  name: Path<FieldsType>;
  control: Control<FieldsType>;
  rules?: RegisterOptions<FieldsType>;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  label?: string;
  required?: boolean;
  shouldUnregister?: boolean;
  placeholder?: string;
  requiredMessage?: string;
  defaultValue?: FieldPathValue<FieldsType, Path<FieldsType>>;
  className?: string;
  labelClassName?: string;
}

const InputText = <FieldsType extends FieldValues>({
  placeholder,
  type,
  label,
  name,
  control,
  required,
  shouldUnregister,
  requiredMessage,
  rules,
  inputProps,
  defaultValue,
  className = "",
  labelClassName = "",
}: InputTextProps<FieldsType>) => {
  return (
    <Controller
      name={name}
      shouldUnregister={shouldUnregister}
      defaultValue={defaultValue}
      control={control}
      rules={{
        required: requiredMessage || (required && "Required"),
        ...(rules || {}),
        validate: (value = "") => {
          value ||= "";
          return (requiredMessage || required) &&
            value.toString().trim().length === 0
            ? "Required"
            : true;
        },
      }}
      render={({ field, fieldState: { error } }) => (
        <div className={`relative ${className}`}>
          {label && (
            <label
              className={`inline-block text-gray-500 pb-1 text-sm ${labelClassName}`}
            >
              {label}
              {(required || requiredMessage) && (
                <span className="text-red-600 ml-0.5 text-base">*</span>
              )}
            </label>
          )}
          <input
            id={field.name}
            {...field}
            {...(inputProps || {})}
            type={type}
            placeholder={placeholder || label}
            className={`w-full appearance-none border border-gray-300 px-3 py-2.5 rounded-lg disabled:bg-gray-50 disabled:border-gray-200 text-gray-900 placeholder-gray-500 invalid:border-1 invalid:border-red-500 focus:outline-none focus:shadow-none focus:ring-0 focus:border-gray-900 text-sm bg-gray-50 `}
          />
          <p className="text-red-600 font-normal text-sm m-0 p-0 ml-1  bottom-0 left-0 right-0">
            {error?.message}
          </p>
        </div>
      )}
    />
  );
};

export default InputText;
